import React, { useState, useEffect } from 'react';

import { MetaTags } from 'react-meta-tags';
import { DashBreadcrumb } from '../../../components/Common/Breadcrumb';
//../../../components/Common/Breadcrumb
import {
  Button,
  Card,
  CardHeader,
  CardTitle,
  Col,
  Container,
  FormGroup,
  Input,
  Row,
  Spinner,
} from 'reactstrap';
import { fetchStoreOrderList } from './action';
import { useDispatch } from 'react-redux';
import StoreOrderList from './components/StoreOrderList';

const StoreOrders = () => {
  const title = 'Store Orders';
  const [searchText, setSearchText] = useState('');
  const [loading, setLoading] = useState(false);
  const [orderData, setOrderData] = useState([]);
  const dispatch = useDispatch();

  useEffect(() => {
    if (!loading) {
      console.log(orderData, 'orderData');
    }
  }, [orderData, loading]);

  const handleSearch = () => {
    const trimmed = searchText.trim();
    if (trimmed && !loading) {
      fetchDetails(trimmed);
    }
  };

  const fetchDetails = async (query) => {
    setLoading(true);
    try {
      const response = await fetchStoreOrderList({
        params: { search: query },
      });
      if (response && response?.code === 100) {
        setOrderData(response?.orders || []);
      } else {
        setOrderData([]);
      }
    } catch (err) {
      setOrderData([]);
      console.error('Failed to fetch orders:', err);
    } finally {
      setLoading(false);
    }
  };
  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Store ReturnOrders</title>
        </MetaTags>
        <Container fluid>
          {/* Render Breadcrumbs */}
          <Row>
            <Col xl={6}>
              <DashBreadcrumb
                title="Returns"
                breadcrumbItem="Manage Store Return Orders"
              />
            </Col>
          </Row>
          <Row>
            <Col>
              <div
                className="p-3 bg-soft-light border-1 border-light d-flex justify-content-between align-items-center"
                style={{ borderStyle: 'dashed' }}
              >
                <h5 className="mb-0 d-flex align-items-center">
                  <i className="bx bx-package me-2"></i>
                  <span>
                    {orderData.length > 0
                      ? `${orderData.length} Orders found with ${searchText}`
                      : 'Search with mobile number or Order reference'}
                  </span>
                </h5>
                <FormGroup
                  className="position-relative w-100"
                  style={{ maxWidth: 400 }}
                >
                  <Input
                    type="text"
                    className="form-control form-control"
                    placeholder="🔍 Enter Mobile Number or Order No..."
                    value={searchText}
                    onChange={(e) => setSearchText(e.target.value)}
                    autoFocus
                    onKeyDown={(e) => {
                      if (e.key === 'Enter') {
                        e.preventDefault();
                        handleSearch();
                      }
                    }}
                  />
                  <Button
                    color="primary"
                    className="position-absolute top-0 end-0"
                    onClick={handleSearch}
                    disabled={loading}
                  >
                    {loading ? (
                      <Spinner size="sm" />
                    ) : (
                      <span>
                        <i className="bx bx-search-alt align-middle"></i> Search
                      </span>
                    )}
                  </Button>
                </FormGroup>
              </div>
            </Col>
          </Row>

          <Row>
            {loading ? (
              <Col md={12} className="text-center p-5">
                <Spinner color="primary" />
              </Col>
            ) : orderData.length > 0 ? (
              <Col md={12}>
                <StoreOrderList orderData={orderData} searchText={searchText} />
              </Col>
            ) : (
              <Col md={12} className="text-center p-5">
                <p>No orders found.</p>
              </Col>
            )}
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};
export default StoreOrders;
